module.exports = __webpack_public_path__ + "img/002.f354dd9e.jpg";